<template>
    <v-app-bar
        color="primary"
        dark
        app
    >
        <v-app-bar-title>Matador Forecasting</v-app-bar-title>
        <v-spacer></v-spacer>
        <v-tabs
            icons-and-text
            v-model="tab"
            right>
            <v-tab v-for="(link,index) in links" 
            :key="index"
            :href="link.path">
                {{ link.title }}
                <v-icon>{{ link.icon }}</v-icon>
            </v-tab>
        </v-tabs>
    </v-app-bar>
</template>

<script>
export default {
    beforeMount() {
        this.tab = this.$props.currentNavigation
    },
    props: {
        currentNavigation: ''
	},
    data: () => ({
        tab: null,
        links: [
            {title: 'Home', path: '/', icon: 'mdi-home'},
            {title: 'Assign Lists', icon: 'mdi-account-box', path: '/accounts'},
            {title: 'Update Products', icon: 'mdi-currency-usd', path: '/products'},
            {title: 'Forecast Categories', icon: 'mdi-shape', path: '/categories'},
        ]
    }),

}
</script>

<style>

</style>